import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { canViewAnalyticsPermission } from 'hooks/usePermission'

// Permanent redirect: the legacy Smart Signals → Bot Detection page was replaced by /bot-detection.
export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/botd')({
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)

    throw redirect({
      to: '/workspaces/$subscriptionId/bot-detection',
      params: ctx.params,
      replace: true,
    })
  },
})
